import axios from 'axios';
import { handleLogOut } from '@velzon/utils/auth/index.js';
import ENVIRONMENT_CONFIG from '@velzon/config/environment.config.js';

const axiosInstance = axios.create({
  baseURL: ENVIRONMENT_CONFIG.REACT_APP_API_BASE_URL,
  withCredentials: true
});

export function setAxiosAuthorizationHeader (token) {
  if(!token) return
  axiosInstance.defaults.headers.common["Authorization"] = `Basic ${token}`;
}
// intercepting to capture errors
axiosInstance.interceptors.response.use(
  function (response) {
    //   console.log('axios.interceptors_response_custom: ',response);
    return response;
    //   return response.data ? response.data : response;
  },
  function (error) {
    //   console.log('axios.interceptors.error_custom: ',error.response);
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.response.status) {
    // case 500:
    //   message = "Internal Server Error";
    //   break;
    case 401:
      // eslint-disable-next-line no-unused-vars
      message = "Unauthorized";
      window.location.assign(`${window.location.origin}/login`);
      handleLogOut();
      break;
      // case 404:
      //   message = "Sorry! the data you are looking for could not be found";
      //   break;
    default:
        //   message = error.message || error;
    }
    return Promise.reject(error);
  }
);
export default axiosInstance